type PropTypes = {
  className?: string
}

const BrandIcon = ({ className }: PropTypes) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      className={className}
    >
      <path
        fill="currentColor"
        d="M16 .244c.802 0 1.434.632 1.595 1.418a16.406 16.406 0 0 0 12.743 12.743c.786.161 1.419.793 1.419 1.595 0 .802-.633 1.434-1.419 1.595a16.406 16.406 0 0 0-12.743 12.743c-.16.785-.793 1.418-1.595 1.418-.802 0-1.433-.633-1.594-1.418A16.406 16.406 0 0 0 1.663 17.595C.877 17.434.244 16.802.244 16c0-.802.633-1.434 1.419-1.595A16.406 16.406 0 0 0 14.406 1.662C14.566.876 15.198.244 16 .244Z"
      />
    </svg>
  )
}

export default BrandIcon
